export var HealthCheckCategory;
(function (HealthCheckCategory) {
    HealthCheckCategory["System"] = "system";
    HealthCheckCategory["Game"] = "game";
    HealthCheckCategory["Mods"] = "mods";
    HealthCheckCategory["Requirements"] = "requirements";
    HealthCheckCategory["Tools"] = "tools";
    HealthCheckCategory["Performance"] = "performance";
    HealthCheckCategory["Legacy"] = "legacy";
})(HealthCheckCategory || (HealthCheckCategory = {}));
export var HealthCheckSeverity;
(function (HealthCheckSeverity) {
    HealthCheckSeverity["Info"] = "info";
    HealthCheckSeverity["Warning"] = "warning";
    HealthCheckSeverity["Error"] = "error";
    HealthCheckSeverity["Critical"] = "critical";
})(HealthCheckSeverity || (HealthCheckSeverity = {}));
export var HealthCheckTrigger;
(function (HealthCheckTrigger) {
    HealthCheckTrigger["Manual"] = "manual";
    HealthCheckTrigger["Startup"] = "startup";
    HealthCheckTrigger["GameChanged"] = "game-changed";
    HealthCheckTrigger["ProfileChanged"] = "profile-changed";
    HealthCheckTrigger["ModsChanged"] = "mods-changed";
    HealthCheckTrigger["ResultsChanged"] = "health-check-results-changed";
    HealthCheckTrigger["SettingsChanged"] = "settings-changed";
    HealthCheckTrigger["PluginsChanged"] = "plugins-changed";
    HealthCheckTrigger["LootUpdated"] = "loot-updated";
    HealthCheckTrigger["Scheduled"] = "scheduled";
})(HealthCheckTrigger || (HealthCheckTrigger = {}));
